import React, { useState, useEffect } from "react";
import { useNavigate, useParams , useLocation } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "../child/Loder";

const ViewSupportTicket = () => {
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Error Message
  const [ItemData, setItemData] = useState([]);
  const [RenterName, setRenterName] = useState("");
  const [HostName, setHostName] = useState("");
   const [loading, setLoading] = useState(true); // State to handle loading
   const location = useLocation();
   const { item } = location.state || {};
  
  const { id } = useParams();
  const isEditMode = !!id;
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return; // Ensure id is defined before making the request
  }, [isEditMode, id]);
  
  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        {successMessage && (
          <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />
        )}
        {errorMessage && (
          <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />
        )}
      </div>

      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="row">
              <div className="col-md-4">
              <span ><strong>Title:</strong>  </span><p>{item?.title}</p>
              </div>
              <div className="col-md-4">
                <span><strong>Message:</strong> </span> {item?.message}
              </div>
              <div className="col-md-4">
                <span><strong>Ticket Status:</strong> </span> {item?.status}
              </div>
              <div className="col-md-4">
                <span><strong>User Name:</strong> </span> {item?.firstName} {item?.lastName}
              </div>
              <div className="col-md-4">
                <span><strong>User Email:</strong> </span> {item?.email}
              </div>

              <div className="col-md-4" style={{ display: "flex"}}>
                <span ><strong>Ticket Genrated Date:</strong>&nbsp; </span>
                <p>
                  {item?.createdAt
                    ? (() => {
                        const date = new Date(item.createdAt);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(2, "0");
                        const year = String(date.getFullYear());
                        return `${day}-${month}-${year}`;
                      })()
                    : "N/A"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSupportTicket;